import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getPapersFormats} from 'src/openapi/admin/apis/GetPapersFormatsApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectPaperFormats} from './services/dictionary-slice';

export const usePaperFormats = () => {
    const apiDispatch = useAppDispatch();
    const paperFormats = useSelector(selectPaperFormats);

    const loadPaperFormats = useCallback(() => {
        if (!paperFormats.length) {
            apiDispatch(getPapersFormats());
        }
    }, [paperFormats.length, apiDispatch]);

    return {paperFormats, loadPaperFormats};
};
